module.exports = __webpack_public_path__ + "img/kolor-03.37201e51.png";